<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplateButton]="innTemplateButtonForm"
    [innTemplate]="enviarTemplateForm" [titulo]="'Aplicación'" [modulo]="'Admin Seguridad'"
    [tituloCard]="'Guardar Aplicacion'">
</app-lfsa-card-v2>

<ng-template #innTemplateButtonForm>
</ng-template>

<ng-template #enviarTemplateForm>
    <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
            <div class="form-group col-md-6">
                <app-lfsa-input [placeholder]="'Ingrese Aplicación'" [label]="'Aplicación'" [id]="'name'"
                    formControlName="application" [control]="formulario.get('application')">
                </app-lfsa-input>
            </div>
        </div>
        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones ( $event )"
            [textBoton]="textBoton"></app-lfsa-botones-formulario>
    </form>
</ng-template>

<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButtonAddAplicacion"
    [innTemplate]="enviarTemplate" [titulo]="'Aplicación'" [modulo]="'Admin Seguridad'"
    [tituloCard]="'Listar Aplicaciones'">
</app-lfsa-card-v2>

<ng-template #innTemplateButtonAddAplicacion>
    <div class="col-md-6">
        <div class="pagetitle">
            <div class="btn-group-justified btn-group" style="float: right;">
                <a class="btn btn-outline-success" (click)="nuevo()">
                    <span class="fa fa-plus"></span>
                    {{DAT_BTNS.agregarAplicacion}}</a>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #enviarTemplate>
    <ag-grid-angular class="{{diccionarioModulo.agGrid.class}}" [floatingFilter]="true" #agGrid
        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</ng-template>
